
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nft",
      function () {
        return require("private-next-pages/nft/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nft"])
      });
    }
  